var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "12px",
    viewBox: "0 0 13 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "archive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header",
    transform: "translate(-506.000000, -9.000000)",
    fill: "#7450C8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(500.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2,7.15 L7.8,7.15 C8.15898509,7.15 8.45,6.85898509 8.45,6.5 C8.45,6.14101491 8.15898509,5.85 7.8,5.85 L5.2,5.85 C4.84101491,5.85 4.55,6.14101491 4.55,6.5 C4.55,6.85898509 4.84101491,7.15 5.2,7.15 Z M11.05,0 L1.95,0 C0.873044738,0 -1.55431223e-16,0.873044738 -4.4408921e-16,1.95 L-4.4408921e-16,3.9 C-4.4408921e-16,4.25898509 0.291014913,4.55 0.65,4.55 L1.3,4.55 L1.3,9.75 C1.3,10.8269553 2.17304474,11.7 3.25,11.7 L9.75,11.7 C10.8269553,11.7 11.7,10.8269553 11.7,9.75 L11.7,4.55 L12.35,4.55 C12.7089851,4.55 13,4.25898509 13,3.9 L13,1.95 C13,0.873044738 12.1269553,0 11.05,0 Z M10.4,9.75 C10.4,10.1089851 10.1089851,10.4 9.75,10.4 L3.25,10.4 C2.89101491,10.4 2.6,10.1089851 2.6,9.75 L2.6,4.55 L10.4,4.55 L10.4,9.75 Z M11.7,3.25 L1.3,3.25 L1.3,1.95 C1.3,1.59101491 1.59101491,1.3 1.95,1.3 L11.05,1.3 C11.4089851,1.3 11.7,1.59101491 11.7,1.95 L11.7,3.25 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.f6dc8612726c5b2734a5e6397f9998c7.svg";
export { ForwardRef as ReactComponent };